// Class: lime._internal.format.LZMA

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var LZMA = function(){}

// Meta

LZMA.__name__ = "lime._internal.format.LZMA";
LZMA.__isInterface__ = false;
LZMA.prototype = {
	
};
LZMA.prototype.__class__ = LZMA.prototype.constructor = $hxClasses["lime._internal.format.LZMA"] = LZMA;

// Init



// Statics

LZMA.compress = function(bytes) {
	return null;
}
LZMA.decompress = function(bytes) {
	return null;
}


// Export

exports.default = LZMA;